import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import ClonePlayerCredentials from "./ClonePlayerCredentials";
import ClonePlayerInputForm from "./ClonePlayerInputForm";
import CloneErrorDialog from "./CloneErrorDialog";
import CheckList from "./CheckList";
import SubAgentTreeDialog from "./SubAgentTreeDialog";
import constants from "../../util/constants";
import http from "../../util/http";
import validator from "validator";
import { CookieStorage } from "cookie-storage";
import initialState from "./initialState";
import { MuiThemeProvider } from "@material-ui/core/styles";
import aceTheme from "../../util/aceTheme";
const cookieStorage = new CookieStorage();

const styles = (theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  button: {
    margin: theme.spacing.unit,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
});

class ClonePlayerDialog extends React.Component {
  state = { ...initialState };
  handleClose = () => {
    this.props.onCloseModal(this.props.selectedValue);
  };

  handleListItemClick = (value) => {
    this.props.onCloseModal(value);
  };
  async componentDidUpdate(prevProps) {
    try {
      const { selectedPlayerId } = this.props;
      if (prevProps.selectedPlayerId !== selectedPlayerId) {
        const selectedPlayer = await http.sendHelperCommand(
          "PlayerDetailHelper.aspx",
          { player: selectedPlayerId },
        );
        let skinData = { SignupPrefix: "PLR" };
        try {
          skinData = JSON.parse(cookieStorage.getItem(constants.SKIN_DATA));
        } catch (e) {
          console.log(e);
        }
        const prefix = "PLR";
        const clonePlayerData = {
          newAutoAccountMode: true,
          anchorEl: null,
          accountID: `${prefix}####`,
          password: "",
          accessOptions: [
            { name: "Enabled", isChecked: selectedPlayer.Enable },
            { name: "Web Access", isChecked: selectedPlayer.EnableOnline },
          ],
          provisionOptions: [
            { name: "Sports", isChecked: selectedPlayer.EnableSport },
            { name: "Horses", isChecked: selectedPlayer.EnableHorses },
            { name: "Casino", isChecked: selectedPlayer.EnableCasino },
            /*{ name: "Parlay", isChecked: selectedPlayer.EnableCards }*/
          ],
          creditLimit: parseFloat(selectedPlayer.CreditLimit, 10).toFixed(2),
          phoneLimitMin: parseFloat(selectedPlayer.MinWager, 10).toFixed(2),
          phoneLimitMax: parseFloat(selectedPlayer.MaxWager, 10).toFixed(2),
          webLimitMin: parseFloat(selectedPlayer.OnlineMinWager, 10).toFixed(2),
          webLimitMax: parseFloat(selectedPlayer.OnlineMaxWager, 10).toFixed(2),
          settleFigure: parseFloat(selectedPlayer.SettledFigure, 10).toFixed(2),
          firstName: selectedPlayer.FirstName,
          lastName: selectedPlayer.LastName,
          phone: selectedPlayer.Phone,
          email: selectedPlayer.Email,
        };
        this.setState({
          loadedPlayer: true,
          selectedPlayer,
          clonePlayerData,
          selectedSubAgent: parseInt(selectedPlayer.IdAgent, 10),
          selectedSubAgentName: selectedPlayer.Agent,
        });
      }
    } catch (err) {
      this.setState({
        cloneErrors: [err.message],
      });
    }
  }
  async componentDidMount() {
    try {
      const subAgentSearch = await http.sendHelperCommand(
        "PerformSubAgentSearchHelper.aspx",
        {},
      );
      if (subAgentSearch.SubAgents.length) {
        this.setState({
          subAgentSearchData: subAgentSearch,
          selectedSubAgent: -1,
          selectedSubAgentName: "Select a Sub Agent",
        });
      } else {
        this.setState({
          selectedSubAgent: cookieStorage.getItem(constants.AGENT_ID),
          selectedSubAgentName: "",
          showSelectSubAgent: false,
          subAgentSearchData: subAgentSearch,
        });
      }
    } catch (err) {
      this.setState({
        cloneErrors: [err.message],
      });
    }
  }
  handlePropChange = (prop) => (event) => {
    const { clonePlayerData } = this.state;
    const propChangedClonePlayerData = { ...clonePlayerData };
    let newValue = event.target.value;
    if (prop === "password") {
      newValue = newValue.toLowerCase();
    }
    if (prop === "accountID") {
      newValue = newValue.toUpperCase();
    }
    propChangedClonePlayerData[prop] = newValue;
    this.setState({
      clonePlayerData: propChangedClonePlayerData,
    });
  };
  swapEditAccountId = () => {
    const { clonePlayerData } = this.state;
    const newClonePlayerData = { ...clonePlayerData };
    const skinData = JSON.parse(cookieStorage.getItem(constants.SKIN_DATA));
    const swapped = !newClonePlayerData.newAutoAccountMode;
    if (swapped) {
      const prefix = "PLR";
      newClonePlayerData["accountID"] = `${prefix}####`;
    } else {
      newClonePlayerData["accountID"] = "";
    }
    newClonePlayerData["newAutoAccountMode"] = swapped;
    this.setState({
      clonePlayerData: newClonePlayerData,
    });
  };
  checkAccountExistence = async (accountID) => {
    try {
      if (accountID !== "") {
        /*const commandMessageParse = await http.sendCommand(
          "command:player:add:suggest",
          { accountID }
        );*/
        const suggestData = await http.sendHelperCommand(
          "PlayerAddSuggestHelper.aspx",
          { account: accountID },
        );
        this.setState({
          suggestData,
        });
      } else {
        this.setState({
          cloneErrors: [
            "Choose an Account ID or press 'Use Default' to have one auto-assigned",
          ],
        });
      }
    } catch (err) {
      this.setState({
        cloneErrors: [err.message],
      });
    }
  };
  handleClonePropChange = (prop, value) => {
    const { clonePlayerData } = this.state;
    const newClonePlayerData = { ...clonePlayerData };
    newClonePlayerData[prop] = value;
    this.setState({
      clonePlayerData: newClonePlayerData,
    });
  };
  handleCloneOptions = (typeName, valueName) => {
    const { clonePlayerData } = this.state;
    const newClonePlayerData = { ...clonePlayerData };
    const oldState = newClonePlayerData[`${typeName}Options`];
    const newState = oldState.map((option) => {
      if (option.name === valueName.name) {
        option.isChecked = !option.isChecked;
      }
      return option;
    });
    newClonePlayerData[`${typeName}Options`] = newState;
    this.setState({
      clonePlayerData: newClonePlayerData,
    });
  };
  createClone = async () => {
    try {
      const { selectedPlayerId } = this.props;
      const { clonePlayerData, selectedSubAgent } = this.state;
      const errors = [];
      const clonePlayer = clonePlayerData;
      if (this.state.selectedSubAgent === -1) {
        errors.push("You have to select a Sub Agent");
      }
      if (!clonePlayer.newAutoAccountMode && clonePlayer.accountID !== "") {
        //const commandMessageParse = await http.sendCommand("command:player:add:suggest",
        const suggestData = await http.sendHelperCommand(
          "PlayerAddSuggestHelper.aspx",
          { account: clonePlayer.accountID },
        );
        if (suggestData.available === 0) {
          errors.push("That Account ID is already reserved by the system.");
        }
      }
      if (!clonePlayer.newAutoAccountMode && clonePlayer.accountID === "") {
        errors.push(
          "Choose an Account ID or press 'Use Default' to have one auto-assigned",
        );
      }
      if (
        clonePlayer.password.length <= 2 ||
        clonePlayer.password.length > 10
      ) {
        errors.push("Password should be between 2 and 10 characters.");
      }
      if (!validator.isDecimal(clonePlayer.settleFigure)) {
        errors.push("Settle figure must be a whole number.");
      }
      if (!validator.isDecimal(clonePlayer.creditLimit)) {
        errors.push("Credit limit must be a whole number.");
      }
      if (!validator.isDecimal(clonePlayer.webLimitMax)) {
        errors.push("Web maximum must be a whole number.");
      }
      if (!validator.isDecimal(clonePlayer.webLimitMin)) {
        errors.push("Web minimum must be a whole number.");
      }
      if (!validator.isDecimal(clonePlayer.phoneLimitMin)) {
        errors.push("Phone minimum must be a whole number.");
      }
      if (!validator.isDecimal(clonePlayer.phoneLimitMax)) {
        errors.push("Phone maximum must be a whole number.");
      }
      if (
        parseInt(clonePlayer.webLimitMin, 10) >
        parseInt(clonePlayer.webLimitMax, 10)
      ) {
        errors.push("The web maximum should be higher than the minimum.");
      }
      if (
        parseInt(clonePlayer.phoneLimitMin, 10) >
        parseInt(clonePlayer.phoneLimitMax, 10)
      ) {
        errors.push("The phone maximum should be higher than the minimum.");
      }
      if (errors.length) {
        this.setState({
          cloneErrors: errors,
        });
      } else {
        const skinData = JSON.parse(cookieStorage.getItem(constants.SKIN_DATA));
        const prefix = "PLR";
        clonePlayer.provisionOptions.push({ name: "Parlay", isChecked: true });
        this.setState({
          processingClone: true,
        });
        clonePlayer.accountID = clonePlayer.accountID.substring(0, 10);
        // const commandMessageParse = await http.sendCommand("command:player:add:clone"
        const playerAddClone = JSON.stringify({
          ...clonePlayer,
          prefix,
          cloneID: selectedPlayerId,
          subAgentId: selectedSubAgent,
        });
        const playerAddCloneData = await http.sendHelperCommand(
          "PlayerAddCloneHelper.aspx",
          { payload: playerAddClone },
        );
        this.setState({
          processingClone: false,
        });
        const cloneResult = playerAddCloneData;
        if (cloneResult.Account) {
          alert(
            `Player Clone Success: Account ${cloneResult.Account}, Password: ${cloneResult.Password}`,
          );
          window.location.reload();
        } else {
          if (cloneResult.Message) {
            this.setState({
              processingClone: false,
              cloneErrors: [cloneResult.Message],
            });
          }
        }
      }
    } catch (err) {
      this.setState({
        processingClone: false,
        cloneErrors: [err.message],
      });
    }
  };
  selectSubAgent = (prmIdAgent, agentName) => {
    this.setState({
      selectedSubAgent: prmIdAgent,
      selectedSubAgentName: agentName,
      openClonedSubAgent: !this.state.openClonedSubAgent,
    });
  };
  handleCloseCloneError = () => {
    this.setState({
      cloneErrors: [],
    });
  };
  handleCloseClonedSubAgent = () => {
    this.setState({
      openClonedSubAgent: !this.state.openClonedSubAgent,
    });
  };
  render() {
    //const skinData = JSON.parse(cookieStorage.getItem(constants.SKIN_DATA));
    const prefix = "PLR";
    const { classes, showModal, onCloseModal } = this.props;
    const {
      cloneErrors,
      suggestData,
      loadedPlayer,
      selectedPlayer,
      processingClone,
      clonePlayerData,
      selectedSubAgent,
      showSelectSubAgent,
      subAgentSearchData,
      openClonedSubAgent,
      selectedSubAgentName,
    } = this.state;

    let subAgentBtnLegend = "";
    if (subAgentSearchData.IdAgent === `${selectedSubAgent}`) {
      subAgentBtnLegend = subAgentSearchData.Agent;
    } else {
      subAgentBtnLegend = selectedSubAgentName;
    }
    if (subAgentBtnLegend.length === 0) {
      subAgentBtnLegend = "Loading...";
    }
    return (
      <MuiThemeProvider theme={aceTheme}>
        <CloneErrorDialog
          {...{
            cloneErrors,
            handleCloseCloneError: this.handleCloseCloneError,
          }}
        />
        <SubAgentTreeDialog
          {...{
            IdAgent: cookieStorage.getItem(constants.AGENT_ID),
            SubAgents: subAgentSearchData.SubAgents,
            selectSubAgent: this.selectSubAgent,
            selectedSubAgent: `${selectedSubAgent}`,
            openClonedSubAgent,
            handleCloseClonedSubAgent: this.handleCloseClonedSubAgent,
          }}
        />
        <Dialog
          onClose={onCloseModal}
          aria-labelledby="simple-dialog-title"
          open={showModal}
        >
          <DialogTitle id="simple-dialog-title">Clone Player</DialogTitle>
          <DialogContent>
            <div className={classes.content}>
              {loadedPlayer && (
                <React.Fragment>
                  <Typography align="left" variant="display1" component="h1">
                    Add New Player (Based on {selectedPlayer.Player})
                  </Typography>
                  <Card className={classes.card}>
                    <CardContent>
                      <ClonePlayerCredentials
                        {...{
                          prefix,
                          suggestData,
                          clonePlayer: clonePlayerData,
                          handlePropChange: this.handlePropChange,
                          swapEditAccountId: this.swapEditAccountId,
                          checkAccountExistence: this.checkAccountExistence,
                          handleClonePropChange: this.handleClonePropChange,
                        }}
                      />
                      <div className={classes.margin}>
                        {showSelectSubAgent && (
                          <React.Fragment>
                            <Typography variant="headline" component="h3">
                              Under what sub-agent should this player be added?
                            </Typography>
                            <Button
                              color="primary"
                              variant="contained"
                              onClick={this.handleCloseClonedSubAgent}
                              className={classes.button}
                            >
                              {subAgentBtnLegend}
                            </Button>
                          </React.Fragment>
                        )}
                        <CheckList
                          {...{
                            title: "Access",
                            type: "access",
                            optionList: clonePlayerData.accessOptions,
                            handleCloneOptions: this.handleCloneOptions,
                          }}
                        />
                        <CheckList
                          {...{
                            title: "Provisions",
                            type: "provision",
                            optionList: clonePlayerData.provisionOptions,
                            handleCloneOptions: this.handleCloneOptions,
                          }}
                        />
                        <ClonePlayerInputForm
                          {...{
                            clonePlayer: clonePlayerData,
                            handlePropChange: this.handlePropChange,
                          }}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </React.Fragment>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={onCloseModal}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={processingClone}
              onClick={this.createClone}
              className={classes.button}
            >
              Create New Account
            </Button>
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

ClonePlayerDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func,
  selectedValue: PropTypes.string,
  selectedPlayerId: PropTypes.string,
};

const ClonePlayerDialogWrapped = withStyles(styles)(ClonePlayerDialog);
export default ClonePlayerDialogWrapped;
